<div *ngIf="CMSData" class="col-lg-12">
   <div class="logout"> 
      <span class="reflect-modal-close" aria-hidden="true">
         <img class="cms-icon-pos" src="{{CMSData.imageUrl_LoggedOutTick}}">
      </span>
	   <div class="logout-message" id="logoutMessage">
          <span *ngIf="isUserLogin" role="heading" aria-level="1">{{CMSData.string_LoggedOutWording}}</span>
          <span *ngIf="isUserLogin" role="heading" aria-level="1">{{CMSData.stringGroup_SavedQuoteWording}}</span>
          
          <span *ngIf="!isUserLogin" role="heading" aria-level="1">{{CMSData.string_TimedOut}}</span>
       </div>
	   <div>
	      <button id="loginagain" class="logInAgain reflect-logout" (click)="logInAgain()" tabindex="0" (keyup.enter)="logInAgain()" *ngIf="isUserLogin">
	        <span> {{CMSData.string_LogInAgainCTALabel}}</span>
	      </button>
		   <button id="loginagain" class="logInAgain reflect-logout" (click)="logInAgain()" tabindex="0" (keyup.enter)="logInAgain()" *ngIf="!isUserLogin">
	        <span>{{CMSData.string_NewQuoteCTALabel}}</span>   
	      </button>
	   </div>
	  
       <div class="form-field logout-landg"> 
          <!-- https://www.legalandgeneral.com -->
         <a id="landgLink" name="landgLink" tabindex="0" target="_blank" href="https://www.legalandgeneral.com/retirement/our-products" class="logout-landg-link">
            {{CMSData.string_RetirementHomePageLinkText}}</a>
       </div>
   </div>
  


</div>
